import React from 'react';
import { Outlet } from 'react-router-dom';
import { makeStyles } from '@fluentui/react-components';

const useStyles = makeStyles({
    membershipLayout: {
        backgroundColor: '#f8f9fa',
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
    },
    
    content: {
        flex: 1,
    },
});

export const MembershipLayout: React.FC = () => {
    const styles = useStyles();

    return (
        <div className={styles.membershipLayout}>
            <div className={styles.content}>
                <Outlet />
            </div>
        </div>
    );
};
